export default {
    en: {
      navbar: {  
        company: 'company',
        services: 'services',
        contact: 'contact',
        portal: 'portal',
        quote: 'request quote',
        warehouse: 'Warehousing and Distribution',
        transport: 'Transportation',
        freight: 'Freight Brokerage',

      /* -------1-Home page-------*/
      },
      index: {  /* home referes to index.vue file */
        hiringH1: `We're Hiring, Interested or know some one who is? `,
        hiringH2: `TransPlus is Expanding and we're offering Hiring Bonuses`,
        hiringDTL: `Check out our Career Page`,  
        header: `Stay on course with our <br> Supply Chain Resources`,
        ourpeople: `Our people, our network, and our facilities are your resources. Stay focused on your core business and let us provide you with the support you deserve.`,
        over: `Over <span class="tpgreen">{year} years</span> of logistics <span class="tpgreen">experience.</span>`,
        Warehousedesc: `From a simple and cost-effective warehousing solution to a long-term inventory management system, we commit to providing you a customized approach.`,
        Transpdesc: `Whether you need to move a single pallet across town or an entire truckload across the country, our reliable asset-based division offers flexible transport services.`,
        freightdesc: `Over the years, we have built strong partnerships throughout the supply chain, enabling us to efficiently manage your product distribution. By assessing your needs, we provide custom solutions at competitive rates.`,
        fullspectrum: `<span class="tpgreen">Full </span>Spectrum Services.</span>`,
        fullspectrumDesc: `Utilize our solution based approach, and let us seamlessly service your consumer goods to major retailers in North America.`,
        industry: `We provide services to a wide range of <span class="tpgreen">industries.</span></h2>`,
        privacy: `Privacy Policy`
  
      },
      /* -------2-Company page-------*/
      Career: {
        Career: `Careers`,        
        title: `Our <span class="tpgreen">culture</span>`,
        url: `https://docs.google.com/document/d/e/2PACX-1vSF9Wx31OFl-1itBSfw9D5fNZhaFpPsgHOhkNOtZbgzNRlltjpzhLFB8-OcEUfKtB_Y7dW2cspM-3s2/pub?embedded=true`,
        desc: `
          Each and every role is instrumental in the success of our business. Without our great people working as a team, we would not be nearly as successful as we are today. We take pride in building an inclusive environment in which everyone—regardless of gender, race, religion, age or background—can succeed. Our goal is to create opportunities that allow fulfilling work experiences for everyone. Our culture has been a key element to our consistent growth over the years. 
        `,
        title2: `Join our <span class="tpgreen">team</span>`,
        desc2: `The more the following statements resonate with you, the more likely you will thrive in our workspace: <br>
          <div class="col-md-10 ml-auto mr-auto text-center">  <br>
          <ul style="list-style: none">
            <li>You are resourceful and think strategically</li>
            <li>You learn rapidly and eagerly</li>
            <li>You maintain calm poise in fast-paced environments to draw out the clearest thinking</li>
            <li>Your work is thorough and you pay attention to details</li>
            <li>You nurture and maintain healthy relationships with colleagues and clients</li>
          </ul>
          </div>
        `,
        Info: `Apply here`
      },   
      
      
      Company: {
        About: `About us`,
        Who: `<span class="tpgreen">Who </span> we are`,
        whodesc: `Transplus is a reliable North American supply chain service provider positioned to meet the needs of regional businesses and global brands across Canada and the U.S. We are a privately owned and managed company that offer customized solutions for each client and their specific business needs.`,
        Story: `Our <span class="tpgreen">story.</span>`,
        storydesc: `Founded in 1993 by Vince Mazzei, Transplus began as a local Canadian transport operation. With a clear understanding of the impact of a global economy, we recognized the value of moving merchandise expeditiously across borders. We began by establishing a solid, dependable operation in North America and then grew our international network. Because our customers’ needs have expanded and evolved, so have our services. Today, we manage and distribute consumer goods across the globe.`,
        People: `Our <span class="tpgreen">people.</span>`,
        peopledesc: `Our people work holistically at every stage of supply chain management. Together, we embrace collaboration, diversity, technology, and innovation.`,        
        Promise: `Our promise to <span class="tpgreen">deliver.</span>`,
        Strategy: `Strategically Driven`,
        Strategydesc: `Through clear and measurable objectives, we are dedicated to providing turn-key logistics from departure to destination. Our operating model is based on procedures and policies that we review regularly to ensure efficient and secure operations.`,
        Reliable: `Highly Reliable`,
        Reliabledesc: `Supply chain management is an around the clock business operation. We operate and are available after hours and on weekends. We are solutions oriented and dedicated to doing what it takes to honour our commitments.`,
        Connectivity: `Fueled by Connectivity`,
        Connectivitydesc: `We pride ourselves on building and maintaining long-term regional and international customer and supplier partnerships. Communication through transparency and accountability is at the core of our business.`,
        Tech: `Tech Savvy`,
        Techdesc: `Technology is leveraged to fuel business growth and transfer synergy to all of our services. We promote effective communication between our systems and yours with our cutting-edge electronic data interchange (EDI), warehouse management system (WMS), transportation management system (TMS), and yard management system (YMS).`,
        Green: `Green Perspective`,
        Greendesc: `The need to reduce our corporate carbon footprint (CCF) is a major priority. We adapt our operations and strategies using green alternatives such as running our fleet on eco-friendly fuels.`

      /* -------3-Warehouse page-------*/

      },
      Warehouse: {
        doors: `doors`,
        warehousedesc1: `<span class="tpgreen">Precision </span> and <span class="tpgreen">timing </span> are everything when it comes to storage<span class="tpgreen">.</span>`,
        warehousedesc2: `Our strategically located facilities in Eastern Canada provide access to all major highways, international airports, local water ports, and railways.`,
        warehousedesc3: `Over half a <span class="tpgreen">million square feet</span> <br> of ambient temperature warehousing and distribution space <br> in between <span class="tpgreen">Montreal</span> & <span class="tpgreen">Toronto.</span> <br>`,
        WMS: `WMS - Warehouse Management System`,
        WMSdesc: `Our cutting-edge WMS ensures complete control over your inventory. Real-time information is provided through web portals and Electronic Data Interchange (EDI). Upon request, we will work with you to integrate and map your transactions into or from our WMS. Both our WMS and TMS are interactively linked for greater efficiency.`,
        AIB: `AIB and HACCP Certified`,
        AIBdesc: `Our facilities are AIB and HACCP certified. These globally recognized standards are key requirements that we meet to ensure your products stay safe throughout storage and distribution. From food to consumer products, we are committed to preventing damage and reducing waste.`,
        Customs: `Customs Bonded Warehouses Approved`,
        Customsdesc: `We offer bonded warehouses, should you require this service for storing your import or export goods.`,
        YMS: `YMS - Yard Management System`,
        YMSdesc: `Achieving the right balance of inbound and outbound freight relies on effective yard management. Real-time yard counts and asset activities enable accurate visibility. For seamless operations management, our YMS is integrated with our WMS and TMS.`,        
        Inventory: `Inventory Handling and Consolidation.`,
        Quantity: `Inventory Quantity Management`,
        Quantitydesc: `Minimum and maximum SKU replenishment are provided to better manage quantity levels. Lots can also be placed on quality hold, in quarantine, or held pending, if needed.`,
        Lot: `Lot Management`,
        Lotdesc: `Gain full control over your stock rotation and alert reporting through license plate numbers (LP), dates, or items. We accommodate first in first out (FIFO), last in first out (LIFO), and first expired first out (FEFO) inventory methods.`,
        Pickandpack: `Pick and Pack`,
        Pickdesc: `Our customer-centred approach ensures that each item is carefully handled, packaged, and labelled. Through piece picking, batch picking, or wave picking, all your inventory is scanned for first in first out (FIFO) purposes.`,
        FullPalPick: `Full Pallet Pick`,
        FullPaldesc: `Resort to simpler pallet handling intended for your large amount of inventory. We service to both commercial and industrial industries.`,        
        Customization: `Customization and Light Assembly.`,
        Kitting: `Kitting`,
        kitdesc: `Our trained and skilled staff meticulously separates, groups, and packages your inventory to build your desired kits. Whether you require labelling, repackaging, or light assembly, receive your items in bulk instead of individually with our cost-effective kitting service.`,
        Rework: `Rework and Repair`,
        Reworkdesc: `We efficiently build, package, or reconfigure your display pallets and label or re-label your products accordingly. Quality control checks are also administered to meet your standards prior to dispatch. Additionally, we offer pallet strapping or resealing upon request.`,
        Securing: `Securing`,        
        SecuringDesc: `We provide a complete range of shrink wrapping, box filling, and product strapping services.`,        
        Added: `Added Value Services`,
        FullSuite: `Full Suite of Container Services`,
        FullSuitedesc: `Ship and receive at an international level worry-free. Our coordination skills and great attention to detail will ensure seamless distribution through our bonded facilities.`,
        Deconsolidation: `Deconsolidation`,
        Deconsolidationdesc: `Both timely shipping and long-term storage services are available to your business. We carefully de-stuff your container, properly label your stock, and strategically load it onto pallets.`,
        Consolidation: `Consolidation`,
        Consolidationdesc: `By taking into account the temperature sensitivity or delicate nature of your cargo, we take all necessary measures to block, brace, and secure it accordingly. If needed, we can even load your shipments using heat treated pallets. We aim to eliminate any potential movement during transportation to prevent damage and to secure your cargo.`,
        Crossdocking: `Crossdocking and Transloading`,
        Crossdockingdesc: `Our services ensure your products are transported quickly (within 24 hours). Minimal handling and storage time from the same stock location is cost effective. From machinery to pallets, we handle all types of cargo.`,

      /* -------4-Transportion page-------*/
      },
      Transportion: {
        fsc: `Fuel Surcharge`,
        Transportationdesc1: `Our path to success is rooted in <span class="tpgreen">reliability</span> and <span class="tpgreen">connectivity.</span>`,
        Transportationdesc2: `We cover from regional to national grounds and service to a wide range of industries that produce consumer goods, food-grade products, raw materials, and industrial products. Our individualized solutions help build a reliable and predictable network for your business.`,        
        TMS: `TMS - Transportation Management System`,
        TMSdesc: `TMS boosts effective comprehension for operations, dispatch, and accounting. From real-time information management to optimized delivery routes, TMS allows you to filter by zone, terminal, driver manager, inbound or outbound deliveries, and more. Both our TMS and WMS are interactively linked for greater efficiency.`,
        PrivateFleet: `Private Fleet`,
        PrivateFleetdesc: `Our fleet, which consists of over 400 company owned units, undergoes rigorous maintenance and runs on eco-friendly fuels. We carefully select, train, and manage our drivers to ensure punctual and quality customer centred service.`,
        GPS: `GPS Protected`,
        GPSdesc: `Our dedicated team closely tracks our fleet location at all times. With greater visibility, we can respond quickly in the events of delays. This allows us to get your products to their final destination faster and in their desired condition.`,
        YMS: `YMS - Yard Management System`,
        YMSdesc: `Achieving the right balance of inbound and outbound freight relies on effective yard management. Real-time yard counts and asset activities enable accurate visibility. For seamless operations management, our YMS is integrated with our WMS and TMS.`,        
        private: `We privately own over 400 units that operate in Eastern Canada.`,
        OvertheRoad: `Over the Road`,
        DediTransport: `Dedicated Transport`,
        DediTransportdesc: `Consistency is key when it comes to building a cost-effective system designed for you. By providing specialized equipment and keeping to specific schedules and routes, you are guaranteed on-time deliveries. We understand that demand and needs can fluctuate, and therefore we are quick to adapt.`,
        RefTrailers: `Refrigerated Trailers`,
        RefTrailersdesc: `Our state-of-the-art, temperature-controlled reefers monitor the exact temperature for fresh and frozen goods.`,
        FTL: `FTL - Full Truckload`,
        FTLdesc: `For large shipments, benefit from the perks of our economic point-to-point FTL pick-up and delivery service. Both short and long-haul trips are available options to you.`,
        LTL: `LTL - Less Than Truckload`,
        LTLdesc: `For a smaller freight, take advantage of our multi-stop LTL trucking routes that are planned for both local or long-haul trips.`,
        SpecFreight: `Specialized Freights`,
        SpecFreightdesc: `Secure handling of oversized or overweight freights is key. If you require flatbed transportation, our experienced drivers will move your inventory safely to anywhere in Canada and the U.S.`,        
        ContainerTypes: `Container Types`,
        Global: `Global`,
        Globaldesc: `Our proximity to major highways, international airports, local water ports, and railways facilitates seamless transport. Whether you need to import or export dry goods or temperature-controlled shipments, we can manage your freight transportation at an international level.`,
        Intermodal: `Intermodal`,
        Intermodaldesc: `Through our strong partnerships, we successfully combine multiple modes of transportation so your goods make it to their final destination intact and on time. Whether transported by water, air, or land, we provide you with flexible solutions.`,
        Drayage: `Drayage`,
        Drayagedesc: `Our trucking fleet is equipped to move your intermodal containers to and from Canadian ports and rail terminals.`,

      /* -------5-Freight Brokerage page-------*/
      },
      Freight: {
        FreightBrokdesc1: `We <span class="tpgreen">promote</span> cross-service <span class="tpgreen">collaboration</span>`,
        FreightBrokdesc2: `Our job is to make your life easier by embracing your unique business challenges. By working side by side with esteemed partners in warehousing, distribution, and transportation, we service from coast to coast to Canada and the U.S.`,
        Rates: `Competitive Rates`,
        Carriers: `Pre-Approved Carriers`,
        Interstate: `U.S. Interstate`,
        SinglePoint: `Single Point of Contact`,
        Hours: `Flexible Hours`,
        FTLLTL: `FTL and LTL`,



      /* -------6-Contact page-------*/
      },
      Contact: {
        Git: `Get in touch`,
        Name: `Name`,
        Phone: `Phone Number`,
        Email: `Email`,
        Company: `Company`,
        Position: `Position`,
        BestTime: `Best time to contact you`,
        Additional: `Additional information`,
        Recipient: `Select Recipient`,
        Warehousing: `Warehousing`,
        Transportation: `Transportation`,
        Freightsales: `Freight Brokerage Sales and Consulting`,
        Accounting: `Accounting`,
        HumanRes: `Human Resources`,
        GenInq: `General Inquiry`,
        Message: `Your Message`,      
        SendResume: `Send us your Resume (max 4MB)`,
        Position: `position you are applying for`,
        headoffice: `Head Office`
      },      
      /* -------7-Get a quote page-------*/
      Address: {
        address: `Address`,
        city: `City`,
        postal: `Postal/Zip Code`,
        pickupinfo: `Additional Pickup Info`,        
        deliveryinfo: `Additional Delivery Info`,        
      },
      Quote: {
        ServiceType: `Service Type`,
        AdditionalInformation: `Additional Information`,
        Contact: `Contact information`,            
        DryVan: `Dry Van`,
        weight2: `Weight (in lbs)<br> &nbsp`,
        Industry: `Industry`,
        Request: `Request a quote<span class="tpgreen">.</span>`,
        TransFreight: `Transportation and Freight Brokerage`,
        Location: `Location`,
        Inmethod: `Inbound method`,
        NumberofpalletsT: `Number of pallets <br> &nbsp`,
        NumberofpalletsW: `Number of pallets <br> <span style="font-size:10px">stored at any given time, min. 200</span>`,        
        stored: `stored at any given time, min. 200`,
        palletsize: `Pallet size <br> &nbsp`,
        weight: `Weight (in lbs)<br><span style="font-size:10px">max 2500 lbs per pallet</span>`,
        weight1: `Weight (in lbs)`,
        inboundper: `Inbound orders per month between <b>{inboundStart}</b> and <b>{inboundEnd}</b>`,
        outboundper: `Outbound orders per month between <b>{outboundStart}</b> and <b>{outboundEnd}</b>`,
        prodturn: `Product turnover per year between <b>{turnsstart}</b> and <b>{turnsend}</b>`,
        Inorders: `Inbound orders`,
        Outorders: `Outbound orders`,
        added: `Added value services`,
        pickpack: `Pick and pack`,
        fullpalpick: `Full pallet pick`,
        secure: `Securing`,
        Kitting: `Kitting and assembly`,
        Labelling: `Labelling`,
        rework: `Rework and repair`,
        Stackable: `Stackable pallets`,
        Floor: `Floor loaded and consolidation`,
        Slip: `Slip sheet required`,
        Top: `Top sheet required`,
        CHEP: `CHEP required`,
        trailer: `Trailer`,
        container: `Container`,        
        TranspType: `Transportation type`,
        Dedicated: `Dedicated`,
        FTL: `FTL - Full truckload`,
        LTL: `LTL - Less than truckload`,
        Yard: `Yard services/shunting`,
        Intermodal: `Intermodal`,
        Drayage: `Drayage`,
        reg: `Canadian / Domestic`,
        Servicelevel: `Service level`,
        Interstate: `U.S. Interstate`,
        Crossborder: `Cross border`,
        Expedited: `Expedited`,
        Commodity: `Commodity`,
        Consumergoods: `Consumer goods`,
        Foodgrade: `Food grade`,
        Refrigerated: `Refrigerated`,
        Rawmaterials: `Raw materials`,
        Hazardousmaterials: `Hazardous materials`,
        Specializedequipment: `Specialized equipment`,
        Comments: `Comments`,
        FreightAttr: `Freight attributes  <br> &nbsp`,
        Tailgate: `Tailgate`,
        Flatbed: `Flatbed`,
        Container: `Container`,
        Straightbodytruck: `Straight body truck`,
        Freightattributes: `Freight attributes`,
        resident: `Residential`,
        Stackable: `Stackable`,
        Nonstackable: `Non-stackable`,
        Origininfo: `Origin information`,
        Destinationinfo: `Destination information`,


      },

      /* -------9-General-------*/      
      General: {
        getquotebusiness: `Get a quote for your business <span class="tpgreen">→</span>`,
        Getaquote: `Get a quote`,
        Sendmessage: `Send message`,
        WarehouseDistribution: `Warehousing and Distribution`,
        Transportation: `Transportation`,
        FreightBrokerage: `Freight Brokerage`,
        ServicesRange: `We provide services to a wide range of industries.`,
        TheseIncludes: `These include:`,
        FoodBeverage: `Food and Beverage`,
        ConsumerGoods: `Consumer Goods`,
        eCommerce: `eCommerce`,
        Manufacturing: `Manufacturing`,
        Health: `Healthcare`,
        RetailDis: `Retail Distribution`,
        other: `other`
      },
      
    },
    /* ---------FRENCH DEVISION-----------------------------------------------------------------------------------*/
    fr: {
      navbar: {  
        company: 'Compagnie',
        services: 'Services',
        contact: 'Contact',
        portal: 'Portail',
        quote: 'Obtenir un devis',
        warehouse: 'Entreposage et distribution',
        transport: 'Transport',
        freight: 'Courtage de fret',

      /* -------1-Home page-------*/
      },
      index: {  /* home referes to index.vue file */
        hiringH1: `Nous embauchons! <br> Vous pensez être le candidat parfait ou connaissez quelqu’un? `,
        hiringH2: `TransPlus is Expanding and we're offering Hiring Bonuses`,
        hiringDTL: `visitez notre page carrière.`,   
        header: `<span style="font-size: .8em">Faites bonne route avec nos <br> ressources pour la chaîne d’approvisionnement` + ` <span class = "tpgreen">.</span></span>`,
        ourpeople: `Notre équipe, notre réseau et nos infrastructures sont à votre disposition. Concentrez-vous sur le cœur de métier de votre entreprise et laissez-nous vous fournir le soutien dont vous avez besoin.`,
        over: `Plus de <span class="tpgreen">{year} ans d'expérience</span> en logistique<span class="tpgreen">.</span>`,
        Warehousedesc: `Pour une solution d’entreposage simple et rentable ou un système de gestion des stocks à long terme, nous nous engageons à vous offrir une approche personnalisée.`,
        Transpdesc: `Que vous ayez besoin de transporter une seule palette à l’autre bout de la ville ou un chargement complet à l’autre bout du pays, notre division fiable basée sur les actifs offre des services de transport flexibles.`,
        freightdesc: `Au fil des années, nous avons bâti de solides partenariats dans l’ensemble de la chaîne d’approvisionnement, ce qui nous permet de gérer efficacement votre distribution de produits. Nous offrons des solutions personnalisées à prix concurrentiels basés sur une évaluation de vos besoins.`,
        fullspectrum: `<span class="tpgreen">Services </span>à spectre complet</span>`,
        fullspectrumDesc: `Profitez de notre approche qui est axée sur les solutions et laissez-nous desservir de manière transparente vos biens de consommation auprès des principaux détaillan.`,
        industry: `nous offrons des services à une vaste gamme <span class="tpgreen">d'industries.</span></h2> `,
        privacy: `politique de confidentialité`
      /* -------2-Company page-------*/
      },
      Career: {
        Career: `Carrières`,
        title:  `Notre <span class="tpgreen">culture</span>`,
        url: `https://docs.google.com/document/d/e/2PACX-1vR4RM6R6nkfdvCOZZhTU3TfWkGEQbf2T9rgE9uhgNQTMALKeE7pQwOsKROdZFDqmMKTeVywZN3tTmnZ/pub?embedded=true`,
        desc: `
          Chaque rôle est essentiel au succès de notre entreprise. Le travail d'équipe de notre personnel est à la source de notre succès aujourd’hui. Nous sommes fiers d’opérer dans un environnement de travail inclusif—qui ne tient pas compte de sexe, race, religion, age ou contexte—où tous peuvent réussir. Notre objectif est de créer des opportunités qui permettent des expériences de travail enrichissantes pour tous. Notre culture joue un rôle clé dans notre croissance au fil des ans.
        `,
        title2: `Joignez-vous à notre <span class="tpgreen">équipe</span>`,
        desc2: `Si les déclarations suivantes résonnent en vous, vous aurez de grandes chances d’exceller dans notre milieu de travail: <br>
        <div class="col-md-10 ml-auto mr-auto text-center">  <br>
        <ul style="list-style: none">
            <li>Vous êtes débrouillard et réfléchissez stratégiquement</li>
            <li>Vous apprenez rapidement et avec enthousiasme</li>
            <li>Vous restez calme dans des situations à rythmes rapides, ce qui vous permet d’opter pour la meilleure stratégie à prendre</li>
            <li>Votre travail est méthodique et vous avez un souci du détail</li>
            <li>Vous prônez et maintenez de relations saines envers vos collègues et clients</li>
          </ul>
        </div>
        `,
        Info: `Appliquez ici`       
      },      
      Company: {
        About: `À propos de nous`,
        Who: `Notre <span class="tpgreen">identité.</span>`,
        whodesc: `Transplus est un fiable fournisseur nord-américain de services pour la chaîne d’approvisionnement. Nous sommes parfaitement positionnés pour répondre aux besoins des entreprises régionales comme des marques mondiales, partout au Canada et aux États-Unis. Notre entreprise fermée sous gestion privée offre des solutions adaptées à chacun de ses clients et à leurs besoins commerciaux précis.`,
        Story: `Notre <span class="tpgreen">histoire.</span>`,
        storydesc: `Fondée en 1993 par Vince Mazzei, Transplus a fait ses débuts comme entreprise de transport local canadienne. Notre vision lucide des dynamiques d’une économie mondialisée nous a fait comprendre l’importance de transporter rapidement des marchandises à travers les frontières. Nous nous sommes implantés de manière fiable et solide en Amérique du Nord avant d’étendre notre réseau à l’échelle internationale. Nos services se sont développés et ont évolué au même rythme que les besoins de notre clientèle. Aujourd’hui, nous gérons et distribuons des biens de consommation à l’échelle mondiale.`,
        People: `Notre <span class="tpgreen">équipe.</span>`,
        peopledesc: `Notre équipe entreprend de manière holistique chaque étape de la gestion de la chaîne d’approvisionnement. La collaboration, la diversité, la technologie et l’innovation sont des principes qui nous animent tous.`,        
        
        Promise: `Notre promesse de <span class="tpgreen">livrer.</span>`,
        Strategy: `Conduite stratégique`,
        Strategydesc: `Des objectifs clairs et mesurables sont fixés afin d’assurer une logistique clé en main — du point d’origine à la destination. Notre modèle opérationnel s’appuie sur des politiques et des procédures réévaluées régulièrement pour veiller à l’efficacité et à la sûreté des opérations.`,
        
        Reliable: `Fiabilité hors pair`,
        Reliabledesc: `La gestion de la chaîne d’approvisionnement ne connaît aucun répit. Nous restons actifs et à votre disposition autant les fins de semaine qu’après les heures normales de bureau. Nous opérons en mode solutions et nous faisons tout le nécessaire pour honorer nos engagements.`,
        
        Connectivity: `Réseau connecté`,
        Connectivitydesc: `Nos partenariats à long terme avec des clients et fournisseurs régionaux et internationaux font notre fierté. Notre entreprise est fondée sur la communication, la transparence et la responsabilisation.`,
        
        Tech: `Maîtrise technologique`,
        Techdesc: `La technologie est mise à profit pour alimenter la croissance et créer une synergie entre tous nos services. Nous assurons une communication efficace entre nos systèmes et les vôtres grâce à l’échange de documents informatisés (EDI), à notre système de gestion d’entrepôt (SGE), à notre système de gestion de la cour (SGC) et à notre système de gestion du transport (SGT).`,
       
        Green: `Perspective verte`,
        Greendesc: `La réduction de l’empreinte carbone de notre entreprise est une de nos principales priorités. Nous adaptons nos opérations et nos stratégies en utilisant des solutions vertes, comme des carburants écologiques pour notre flotte de camions.`

      /* -------3-Warehouse page-------*/

      },
      Warehouse: {
        doors: `portes`,
        warehousedesc1: `<span class="tpgreen">Précision </span> and <span class="tpgreen">synchronisation </span> : les clés de l’entreposage<span class="tpgreen">.</span>`,
        warehousedesc2: `Nos emplacements stratégiques dans l’est du Canada offrent un accès à tous les principaux aéroports internationaux, autoroutes, ports locaux et voies ferrées.`,
        warehousedesc3: `Plus d'un <span class="tpgreen">demi-million de pieds carrés </span> <br> d'espace en entreposage et distribution réparti entre <br><span class="tpgreen">Montréal</span> et <span class="tpgreen">Toronto.</span>`,
        WMS: `SGE - Système de gestion d’entrepôt`,
        WMSdesc: `Profitez d’une maîtrise complète de vos stocks grâce à notre SGE de pointe. Les portails Web et le système d’échange de documents informatisés (EDI) fournissent de l’information en temps réel. Sur demande, nous travaillerons avec vous pour intégrer et identifier vos transactions de notre système SGE au vôtre. Nos SGE et SGT sont liés de façon interactive pour une efficacité accrue.`,
        AIB: `Certifications AIB et HACCP`,
        AIBdesc: `Nos infrastructures sont certifiées AIB et HACCP. Nous répondons à ces normes essentielles reconnues mondialement pour assurer la sécurité de vos produits tout au long de l’entreposage et de la distribution. Pour les aliments comme les produits de consommation, nous évitons les dommages et réduisons les pertes.`,
        Customs: `Entrepôts de stockage des douanes approuvés`,
        Customsdesc: `Nous offrons si nécessaire des entrepôts sous le contrôle des douanes pour entreposer vos marchandises à but d’importation ou d’exportation.`,
        YMS: `SGC - Système de gestion de la cour`,
        YMSdesc: `Un bon équilibre entre les chargements entrants et sortants repose sur une gestion efficace de la cour. Le dénombrement et le suivi en temps réel des actifs dans la cour permettent une visualisation précise. Pour une gestion fluide des opérations, notre SGC s’intègre aux SGE et SGT.`,        
        
        Inventory: `Manutention et consolidation des stocks`,
        Quantity: `Gestion des quantités de stocks`,
        Quantitydesc: `Les réapprovisionnements en UGS minimums et maximums sont fournis pour mieux gérer les niveaux de stocks. Des lots peuvent être retenus à des fins de contrôle de la qualité, placés en quarantaine ou mis en attente si nécessaire.`,
        Lot: `Gestion de lots`,
        Lotdesc: `Exercez un contrôle total sur la rotation de vos stocks et obtenez des rapports complets en filtrant par plaques d’immatriculation, dates ou articles. Nous pouvons fonctionner avec les méthodes d’évaluation des stocks du premier entré, premier sorti (PEPS), du dernier entré, premier sorti (DEPS) et du premier périmé, premier sorti (PPPS).`,
        Pickandpack: `Prélèvement et emballage`,
        Pickdesc: `Notre approche axée sur le client veille à ce que chaque article soit soigneusement manipulé, emballé et étiqueté. Avec le prélèvement par article, par lot ou par vague, tous vos stocks sont scannés en fonction de la méthode du premier entré, premier sorti (PEPS).`,
        FullPalPick: `Prélèvement par palette entière`,
        FullPaldesc: `Une manutention de palettes simplifiée, pensée pour de grandes quantités de stocks. Nous offrons ce service aux secteurs commerciaux comme industriels.`,        
        
        Customization: `Personnalisation et assemblage léger`,
        Kitting: `Mise en trousse`,
        Kitdesc: `Notre personnel formé et compétent sépare, regroupe et emballe méticuleusement vos stocks pour créer les trousses souhaitées. Que vous ayez besoin d’un étiquetage, d’un remballage ou d’un assemblage léger, recevez vos articles en vrac plutôt qu’individuellement grâce à notre service de mise en trousse économique.`,
        Rework: `Récupération et réparation`,
        Reworkdesc: `Nous créons, emballons ou reconfigurons efficacement vos palettes de présentation et nous étiquetons ou ré-étiquetons vos produits en conséquence. Nous effectuons aussi des contrôles de qualité pour répondre à vos normes avant la répartition. De plus, nous offrons des services de cerclage ou de revente de palettes sur demande.`,
        Securing: `Arrimage`,
        SecuringDesc: `Profitez de notre gamme complète de services d’emballage par rétraction, de remplissage de boîtes et de cerclage de produits.`,        
        
        Added: `Services à valeur ajoutée.`,
        FullSuite: `Une suite complète de services de conteneurs`,
        FullSuitedesc: `Expédiez et recevez des marchandises à l’échelle internationale sans aucun souci. Nos capacités de coordination et notre grand souci du détail assureront une distribution fluide par l’entremise de nos entrepôts.`,
        Deconsolidation: `Dégroupement`,
        Deconsolidationdesc: `Nous offrons à la fois des services d’expédition rapide et d’entreposage à long terme. Nous déchargeons soigneusement vos conteneurs, nous étiquetons vos stocks de manière souhaitée et nous les chargeons stratégiquement sur des palettes.`,
        Consolidation: `Regroupement`,
        Consolidationdesc: `En prenant en considération la sensibilité thermique ou la nature délicate de vos cargaisons, nous prenons toutes les mesures nécessaires pour les immobiliser, les stabiliser et les retenir comme il se doit. Au besoin, nous pouvons même procéder à leur chargement en utilisant des palettes traitées thermiquement. Notre objectif est d’éliminer tout mouvement possible durant le transport afin de prévenir les dommages et protéger vos cargaisons.`,
        Crossdocking: `Transbordement direct et avec stockage intermédiaire`,
        Crossdockingdesc: `Nos services assurent que vos produits sont transportés rapidement (dans un délai de 24 heures). Une manutention et un délai de stockage minimum dans un même emplacement assurent la rentabilité du service. De la machinerie aux palettes, nous nous occupons de tous les types de chargements.`,

      /* -------4-Transportion page-------*/
      },
      Transportion: {
        fsc: `Supplément Carburant`,
        Transportationdesc1: `Une réussite menée par la <span class="tpgreen">fiabilité</span> et la <span class="tpgreen">connectivité.</span>`,
        Transportationdesc2: `Nous couvrons autant les territoires régionaux que nationaux, tout en desservant un vaste éventail de secteurs produisant des biens de consommation, des produits de qualité alimentaire, des matières premières et des produits industriels. Nos solutions personnalisées créent un réseau fiable et facile à prévoir pour votre entreprise.`,        
        TMS: `SGT - Système de gestion du transport`,
        TMSdesc: `Notre SGT mise sur une compréhension efficace des opérations, de la répartition et de la comptabilité. De la gestion de l’information en temps réel à l’optimisation des itinéraires de distribution, le SGT vous permet une visualisation notamment par zone, par terminal, par gestionnaire de chauffeurs et par livraisons entrantes ou sortantes. Nos SGT et SGE sont liés de façon interactive pour une efficacité accrue.`,
        PrivateFleet: `Flotte privée`,
        PrivateFleetdesc: `Notre flotte composée de plus de 400 unités nous appartenant fait l’objet d’un entretien rigoureux et opère grâce aux carburants écologiques. Nous sélectionnons, formons et gérons nos chauffeurs avec soin pour offrir un service ponctuel et de qualité axé sur un service à la clientèle hors pair.`,
        GPS: `Protection par GPS`,
        GPSdesc: `Notre équipe dévouée suit étroitement et à tout moment l’emplacement des véhicules de notre flotte. Cette visualisation précise nous permet de répondre rapidement à tout délai. Vos produits arrivent donc à destination plus rapidement et dans leur condition souhaitée.`,
        YMS: `SGC - Système de gestion de la cour`,
        YMSdesc: `Un bon équilibre entre les chargements entrants et sortants repose sur une gestion efficace de la cour. Le dénombrement et le suivi en temps réel des actifs dans la cour permettent une visualisation précise. Pour une gestion fluide des opérations, notre SGC s’intègre aux SGE et SGT.`,        
        private: `Nous sommes propriétaire de plus de 400 unités qui opèrent dans l’est Canadien.`,
        
        OvertheRoad: `En route.`,
        DediTransport: `Transport dédié`,
        DediTransportdesc: `La constance est cruciale pour créer un système rentable et conçu pour vous. En fournissant de l’équipement spécialisé et en respectant des horaires et des itinéraires précis, nous assurons des livraisons à temps. Sachant que la demande et les besoins peuvent fluctuer, nous nous adaptons rapidement.`,
        RefTrailers: `Remorques réfrigérées`,
        RefTrailersdesc: `Nos conteneurs réfrigérés de pointe suivent la température exacte des produits frais ou congelés en tout temps.`,
        FTL: `CC - Chargement complet`,
        FTLdesc: `Pour de gros chargements, profitez des avantages de notre service économique de prise en charge et de livraison de chargements complets d’un point à l’autre. Des options de transport de courtes et de longues distances s’offrent à vous.`,
        LTL: `CP - Chargement partiel`,
        LTLdesc: `Pour de plus petits chargements, profitez d’itinéraires à escales multiples pour chargements partiels effectués par camion pour le transport local ou de longues distances.`,
        SpecFreight: `Transport de marchandises spécialisé`,
        SpecFreightdesc: `Les cargaisons plus volumineuses ou lourdes doivent être traitées de manière sécuritaire. Si vous avez besoin d’un transport par remorque à plateau, nos chauffeurs d’expérience pourront s’en charger sécuritairement, partout au Canada et aux États-Unis.`,        
        
        ContainerTypes: `Types de conteneurs.`,
        Global: `Mondial`,
        Globaldesc: `Notre proximité aux principaux aéroports internationaux, autoroutes, ports locaux et voies ferrées assure un transport fluide. Que ce soit pour importer ou exporter des marchandises sèches ou des chargements à température contrôlée, nous pouvons nous charger de transporter votre marchandise à l’échelle internationale.`,
        Intermodal: `Multimodal`,
        Intermodaldesc: `Notre proximité aux principaux aéroports internationaux, autoroutes, ports locaux et voies ferrées assure un transport fluide. Que ce soit pour importer ou exporter des marchandises sèches ou des chargements à température contrôlée, nous pouvons nous charger de transporter votre marchandise à l’échelle internationale.`,
        Drayage: `Drayage`,
        Drayagedesc: `Notre flotte de camions est équipée pour transporter vos conteneurs multimodaux vers des ports et des terminaux ferroviaires canadiens et à partir de ceux-ci.`,

      /* -------5-Freight Brokerage page-------*/
      },
      Freight: {
        FreightBrokdesc1: `Nous valorisons la <span class="tpgreen">collaboration interservices.</span>`,
        FreightBrokdesc2: `Notre travail consiste à vous simplifier la vie en relevant vos défis commerciaux uniques. En travaillant en étroite collaboration avec des partenaires de confiance dans les secteurs de l’entreposage, de la distribution et du transport, nous desservons tout le Canada et les États-Unis.`,
        Rates: `Tarifs concurrentiels`,
        Carriers: `Transporteurs préapprouvés`,
        Interstate: `Transport inter-États aux É.-U.`,
        SinglePoint: `Point de contact unique`,
        Hours: `Horaire flexible`,
        FTLLTL: `Chargements complets et partiels`,



      /* -------6-Contact page-------*/
      },
      Contact: {
        Git: `Communiquez avec nous`,
        Name: `Nom`,
        Phone: `Téléphone`,
        Email: `Courriel`,
        Company: `Company`,
        Position: `Poste`,
        BestTime: `Meilleur moment pour vous rejoindre`,
        Additional: `Information additionnelle`,
        Recipient: `Choisir un destinataire`,
        Warehousing: `Entreposage`,
        Transportation: `Transport`,
        Freightsales: `Courtage de fret et consultation`,
        Accounting: `Comptabilité`,
        HumanRes: `Ressources Humaines`,
        GenInq: `Demande d'information`,
        Message: `Votre message`,
        SendResume: ` Envoyez votre CV (max 4MB)`,
        Position: `poste pour lequel vous appliquez`,
        headoffice: `Siège Social`

      /* -------7-Get a quote page-------*/
      },
      Address: {
        address: `Adresse`,
        city: `Ville`,
        postal: `Code Postal / Zip`,
        pickupinfo: `Informations additionelles pour la cueillette`,        
        deliveryinfo: `Informations additionnelles pour la livraison`,        
      },      
      Quote: {
        ServiceType: `Type de service`,
        AdditionalInformation: `Information complémentaires`,
        Contact: `Coordonnées`,        
        DryVan: ``,
        weight2: `Poids (en lbs)  <br> &nbsp`,
        Industry: `Industrie`,
        Request: `Obtenir un devis<span class="tpgreen">.</span>`,
        TransFreight: `Transport et courtage de fret`,
        Location: `Emplacement`,
        Inmethod: `Mode de transport entrant`,
        Numberofpallets: `Nombre de palettes <br> &nbsp`,
        NumberofpalletsT: `Nombre de palettes <br> &nbsp`,
        NumberofpalletsW: `Nombre de palettes <br> <span style="font-size:10px">stored at any given time, min. 200</span>`,                
        stored: `stockées à tout moment (min. de 200)`,
        palletsize: `Taille des palettes <br> &nbsp`,
        weight: `Poids (en kg)<br><span style="font-size:10px">max 2500 kg par palette</span>`,
        weight1: `Poids (in lbs)`,
        inboundper: `Nombre de commandes entrantes par mois entre<b>{inboundStart}</b> et <b>{inboundEnd}</b>`,
        outboundper: `Nombre de commandes sortantes par mois entre<b>{outboundStart}</b> et <b>{outboundEnd}</b>`,
        prodturn: `Rotation de produits par année entre <b>{turnsstart}</b> et
         <b>{turnsend}</b>`,
        Inorders: `Commandes entrantes`,
        Outorders: `Commandes sortantes`,
        
        added: `Services à valeur ajoutée`,
        pickpack: `Prélèvement et emballage`,
        fullpalpick: `Prélèvement par palette entière`,
        secure: `Arrimage`,
        Kitting: `Mise en trousse et assemblage`,
        Labelling: `Étiquetage`,
        rework: `Récupération et réparation`,
        Stackable: `Palettes empilables`,
        Floor: `Charge au sol et consolidation`,
        Slip: `Slip sheet requis`,
        Top: `Top sheet requis`,
        CHEP: `CHEP requis`,
        trailer: `Remorque`,
        container: `Conteneur`,

        TranspType: `Type de transport`,
        Dedicated: `Transport dédié`,
        FTL: `Chargement complet`,
        LTL: `Chargement partiel`,
        Yard: `Services de cour/manœuvre`,
        Intermodal: `Transport multimodal`,
        Drayage: `Drayage`,
        reg: `Canadien / Domestique`,/*`Régulier`,*/
        Servicelevel: `Niveau de service`,
        Interstate: `Transport inter-États Unis.`,
        Crossborder: `Transport transfrontalier`,
        Expedited: `Transport accéléré`,
        Commodity: `Marchandises`,
        Consumergoods: `Biens de consommation`,
        Foodgrade: `Produits de qualité alimentaire`,
        Refrigerated: `Produits réfrigérés`,
        Rawmaterials: `Matières premières`,
        Hazardousmaterials: `Matières dangereuses`,        
        Specializedequipment: `Équipements spécialisés`,
        Comments: `Comments`,
        FreightAttr: `Attributs du fret  <br> &nbsp`,
        Tailgate: `Remorque à hayon`,
        Flatbed: `Remorque à plateau`,
        Container: `Conteneur`,
        Straightbodytruck: `Camion porteur`,
        Freightattributes: `Caractéristiques du fret`,
        resident: `Résidentiel`,
        Stackable: `Palettes empilables`,
        Nonstackable: `Palette non-empilables`,
        Origininfo: `Renseignements sur l'origine`,
        Destinationinfo: `Renseignements sur la destination`,


      },

      /* -------9-General-------*/      
      General: {
        getquotebusiness: `Obtenir un devis pour votre entreprise <span class="tpgreen">→</span>`,
        Getaquote: `Obtenir un devis`,
        Sendmessage: `Envoyer le message`,
        WarehouseDistribution: `Entreposage et Distribution`,
        Transportation: `Transport`,
        FreightBrokerage: `Courtage de Fret`,
        ServicesRange: `Nos services s’adressent à un vaste éventail de secteurs.`,
        TheseIncludes: `Notamment:`,
        FoodBeverage: `Nourriture et boisson`,
        ConsumerGoods: `Biens de consommation`,
        eCommerce: `Commerce électronique`,
        Manufacturing: `Fabrication`,
        Health: `Soins de santé`,
        RetailDis: `Distribution au détail`,
        other: `Autre`
      },

    }
};